import {  createContext, useState } from "react"

export const UserContext=createContext(null);

const ContextProvider=({children})=>{
    const [account,setAccount]=useState('');
    const [user,setUser]=useState('');
    const [gender,setGender]=useState('');

    return(
        <UserContext.Provider value={{
            account,
            setAccount,user,setUser,gender,setGender
        }}>
        {children}
        </UserContext.Provider>
    )
}

export default ContextProvider;